<script lang="tsx">
  import { defineAsyncComponent } from "vue";
  import { Skeleton } from "primevue";
  const CentreDirectory = defineAsyncComponent(async () => await import("./CentreDirectory.vue"));


  export default {
    components: { Skeleton, CentreDirectory },
    props: CentreDirectory.props as (typeof CentreDirectory["props"]),
  };
</script>

<template>
  <Suspense v-bind.attr="$attrs">
    <CentreDirectory v-bind.attr="$attrs" v-bind.prop="$props as any"/>

    <template #fallback>
      <Skeleton width="100%" height="100%"/>
    </template>
  </Suspense>
</template>
